import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent, BreadcrumbItem } from 'nebula-ui-kit';

/**
 * Muestra `lib-breadcrumb` con los ítems del layout (BreadcrumbSyncService en el padre).
 * La navegación la resuelve el kit vía `routerLink` y `item.route`.
 */
@Component({
  selector: 'app-breadcrumb-wrapper',
  standalone: true,
  imports: [CommonModule, BreadcrumbComponent],
  templateUrl: './breadcrumb-wrapper.component.html',
  styleUrls: ['./breadcrumb-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbWrapperComponent {
  items = input<BreadcrumbItem[]>([]);
}
